"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var normalize_url_1 = __importDefault(require("normalize-url"));
var quill_delta_1 = __importDefault(require("quill-delta"));
var defaults = {
    urlRegularExpression: /(https?:\/\/|www\.)[\w-.]+\.[\w-.]+[\S]+/i,
    normalizeRegularExpression: /(https?:\/\/|www\.)[\S]+/i,
};
var QuillAutoDetectUrl = /** @class */ (function () {
    function QuillAutoDetectUrl(quill, options) {
        this.quill = quill;
        options = options || {};
        this.options = __assign(__assign({}, defaults), options);
        this.globalRegularExpression = new RegExp(this.options.urlRegularExpression, 'gi');
        this.registerPasteListener();
        this.registerTypeListener();
    }
    QuillAutoDetectUrl.prototype.registerPasteListener = function () {
        var _this = this;
        this.quill.clipboard.addMatcher(Node.TEXT_NODE, function (node, delta) {
            if (typeof node.data !== 'string') {
                return;
            }
            var urlRegExp = _this.globalRegularExpression;
            urlRegExp.lastIndex = 0;
            var newDelta = new quill_delta_1.default();
            var index = 0;
            var urlResult = urlRegExp.exec(node.data);
            var handleMatch = function (result, regExp) {
                var head = node.data.substring(index, result.index);
                newDelta.insert(head);
                var match = result[0];
                newDelta.insert(match, { link: _this.urlNormalizer(match) });
                index = regExp.lastIndex;
                return regExp.exec(node.data);
            };
            while (urlResult !== null) {
                urlResult = handleMatch(urlResult, urlRegExp);
            }
            if (index > 0) {
                var tail = node.data.substring(index);
                newDelta.insert(tail);
                delta.ops = newDelta.ops;
            }
            return delta;
        });
    };
    QuillAutoDetectUrl.prototype.registerTypeListener = function () {
        var _this = this;
        this.quill.on('text-change', function (delta) {
            var ops = delta.ops;
            if (!ops || ops.length < 1 || ops.length > 2) {
                return;
            }
            var lastOp = ops[ops.length - 1];
            if (!lastOp.delete && (!lastOp.insert || typeof lastOp.insert !== 'string')) {
                return;
            }
            _this.checkTextForUrl(lastOp.insert);
        });
    };
    QuillAutoDetectUrl.prototype.checkTextForUrl = function (insert) {
        var sel = this.quill.getSelection();
        if (!sel) {
            return;
        }
        var leaf = this.quill.getLeaf(sel.index)[0];
        if (insert === '\n') {
            var nextLeaf = this.quill.getLeaf(sel.index + sel.length + 1)[0];
            if (nextLeaf && nextLeaf.parent.domNode.localName === 'a') {
                this.transformLeaf(nextLeaf);
            }
            this.transformLeaf(leaf);
        }
        else {
            var prevLeaf = this.quill.getLeaf(sel.index - 1)[0];
            if (prevLeaf.parent.domNode.localName === 'a' && prevLeaf.parent.domNode !== leaf.parent.domNode) {
                var url = prevLeaf.text + (leaf.text || '');
                var urlMatch = url.match(this.options.urlRegularExpression);
                if (urlMatch) {
                    var prevQuillIndex = this.quill.getIndex(prevLeaf) + urlMatch.index;
                    // for mboile device (keyboard selection bug)
                    this.quill.removeFormat(prevQuillIndex, prevLeaf.text.length);
                    this.textToUrl(prevQuillIndex, urlMatch[0]);
                }
            }
            else {
                this.transformLeaf(leaf);
            }
        }
    };
    QuillAutoDetectUrl.prototype.transformLeaf = function (leaf) {
        var _a, _b;
        var urlMatch = (_a = leaf.text) === null || _a === void 0 ? void 0 : _a.match(this.options.urlRegularExpression);
        var leafIndex = this.quill.getIndex(leaf);
        if (urlMatch) {
            this.textToUrl(leafIndex + urlMatch.index, urlMatch[0]);
            // for android mobile device keyboard
            // it resolved weird phenomenon when some text infront of www.xxx.xxx link
            this.quill.enable(false);
            this.quill.enable(true);
        }
        else if (leaf.parent.domNode.localName === 'a') {
            this.quill.removeFormat(leafIndex, ((_b = leaf.text) === null || _b === void 0 ? void 0 : _b.length) || 0);
        }
    };
    QuillAutoDetectUrl.prototype.textToUrl = function (index, url) {
        var ops = new quill_delta_1.default().retain(index).retain(url.length, { link: this.urlNormalizer(url) });
        this.quill.updateContents(ops);
    };
    QuillAutoDetectUrl.prototype.urlNormalizer = function (url) {
        if (this.options.normalizeRegularExpression.test(url)) {
            try {
                return normalize_url_1.default(url, this.options.normalizeUrlOptions);
            }
            catch (error) {
                console.error(error);
            }
        }
        return url;
    };
    return QuillAutoDetectUrl;
}());
exports.default = QuillAutoDetectUrl;
